import { selectActivityLog } from "../../../redux/features/activityLog/activityLogSlice";
import { useAppSelector } from "../../../utils/hooks/redux";
import { useMemo } from "react";
import { sortLostItemLogsData } from "../../../utils/helpers/sortStickyData";
import { DefaultUserName, LostItemLogsData } from "../../../types/ActivityLog";
import { SupportEmail } from "../../../utils/constants";
import ActivityLogs from "../../../components/ActivityLogs";
import type { Report } from "../../../types";

interface ReportActivityLogsProps {
    handleEditNoteModalOpen: (type: "add" | "update", item: LostItemLogsData) => void;
    report?: Report | null;
}

const ReportActivityLogs: React.FC<ReportActivityLogsProps> = ({ handleEditNoteModalOpen, report }) => {
    const { data: lostItemLogsData, status: lostItemLogStatus } = useAppSelector(selectActivityLog);
    const lostItemLogsDataSorted = useMemo(() => sortLostItemLogsData(lostItemLogsData), [lostItemLogsData]);

    // Surface the customer's Before-We-Begin consent capture at the top of the log.
    // Prefer the explicit `authorizationsAcceptedAt` timestamp when present (claims
    // submitted after the feature shipped) and fall back to `createdAt` for older
    // claims that pre-date the column — those won't have the real consent timestamp
    // but the admin still gets a visual record-of-consent entry to act on.
    const authorizationsTimestamp =
        (report as any)?.authorizationsAcceptedAt || (report as any)?.createdAt || null;

    return (
        <ActivityLogs
            handleEditNoteModalOpen={handleEditNoteModalOpen}
            logs={lostItemLogsDataSorted}
            status={lostItemLogStatus}
            authorizationsTimestamp={authorizationsTimestamp}
            authorizationsHasExplicitRecord={!!(report as any)?.authorizationsAcceptedAt}
        />
    );
};

export default ReportActivityLogs;
